import styled from "styled-components";
import footerLogoBlack from "../../assets/SKYNE-logo-black.png"

// Styled component named StyledButton
const StyledFooter = styled.div`
    background-color: ${(props) => props.theme.color.disabledgray};
    height: 60px;
    font-size: 32px;
    background-color: ${(props) => props.theme.color.disabledgray};
    position: absolute;
    bottom: 0;
    width: 100%;
`;

const LicenseAndLogo = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: 280px;
    margin-right: auto;
    user-select: none;
    max-width: max-content;
    cursor: pointer;
`;

const License = styled.div`
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    font-size: 10px;
    font-weight: 600;
    line-height: 60px;
`;

const FooterLogo = styled.img`
    width: 50px;
    height: 14px;
    padding-left: 20px;
`;

function Footer() {
  // Use it like any other component.
    return <StyledFooter>
        <LicenseAndLogo>
            <License>System is licenced by</License>
            <FooterLogo src={footerLogoBlack}></FooterLogo>
        </LicenseAndLogo>
    </StyledFooter>;
}

export default Footer;